import { z } from "zod";

export const tideDataSchema = z.object({
	date: z.string(),
	high_tide_1: z.string(),
	high_tide_2: z.string(),
	low_tide_1: z.string(),
	low_tide_2: z.string(),
});

export const tidesDataSchema = z.array(tideDataSchema);

export type typeTidesDataSchema = z.infer<typeof tidesDataSchema>;
export type typetideDataSchema = z.infer<typeof tideDataSchema>;
